import Vue from 'vue';
import store from '../store'
import injector from 'vue-inject';
Vue.use(injector);

const api = injector.get('api');

class Terms {
    fetchData () {
        return new Promise((resolve, reject) => {
            Vue.http.get(api.terms.fetchData).then(response => {
                store.commit('setTerms', response.body)
                resolve();
            }, () => { reject() });
        });
    }

    setAccepted () {
        return new Promise((resolve, reject) => {
            Vue.http.get(api.terms.accepted).then(response => {
                store.commit('setAcceptedTerms', response.body)
                resolve();
            }, () => { reject() });
        });
    }

    sign (data) {
        return new Promise((resolve, reject) => {
            Vue.http.post(api.terms.sign, { signatures : data }).then(() => {
                resolve();
            }, () => { reject() });
        });
    }
}

injector.service('terms', Terms)


// WEBPACK FOOTER //
// ./src/services/terms.js